import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

interface Documento {
  id: number;
  nome: string;
  tipo: string;
  dataVigencia: Date;
  descricao: string;
  arquivo: string;
  status: string;
}

@Component({
  selector: 'app-qualificacao-documental',
  templateUrl: './qualificacao-documental.component.html',
  styleUrls: ['./qualificacao-documental.component.scss']
})
export class QualificacaoDocumentalComponent implements OnInit {
  @ViewChild('modalCadastroDocumento') modalCadastroDocumento: any;
  modalRef: NgbModalRef;
  documentoForm: FormGroup;
  documentos: Documento[] = [];
  isEditing = false;
  dtOptions: DataTables.Settings = {};
  tiposDocumento = [
    { id: 'licenca', nome: 'Licença' },
    { id: 'alvara', nome: 'Alvará' },
    { id: 'laudo', nome: 'Laudo' }
  ];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.documentoForm = this.fb.group({
      nome: ['', [Validators.required]],
      tipo: ['', [Validators.required]],
      dataVigencia: ['', [Validators.required]],
      descricao: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarDocumentos();
  }

  carregarDocumentos() {
    // Implementar chamada à API
    this.documentos = [
      {
        id: 1,
        nome: 'Licença Sanitária',
        tipo: 'licenca',
        dataVigencia: new Date('2024-12-31'),
        descricao: 'Licença sanitária para operação',
        arquivo: 'licenca_sanitaria.pdf',
        status: 'Vigente'
      },
      {
        id: 2,
        nome: 'Alvará de Funcionamento',
        tipo: 'alvara',
        dataVigencia: new Date('2025-06-30'),
        descricao: 'Alvará de funcionamento municipal',
        arquivo: 'alvara_funcionamento.pdf',
        status: 'Vigente'
      },
      {
        id: 3,
        nome: 'Laudo Técnico',
        tipo: 'laudo',
        dataVigencia: new Date('2024-03-15'),
        descricao: 'Laudo técnico de segurança',
        arquivo: 'laudo_tecnico.pdf',
        status: 'Vencido'
      }
    ];
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (!this.isEditing) {
      this.documentoForm.reset();
    }
  }

  abrirModalCadastro() {
    this.documentoForm.reset();
    this.modalRef = this.modalService.open(this.modalCadastroDocumento, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  onSubmit() {
    if (this.documentoForm.valid) {
      // Implementar chamada à API
      console.log('Salvar documento:', this.documentoForm.value);
      this.modalRef.close();
      this.carregarDocumentos();
    }
  }

  editarDocumento(documento: Documento) {
    this.documentoForm.patchValue({
      nome: documento.nome,
      tipo: documento.tipo,
      dataVigencia: documento.dataVigencia,
      descricao: documento.descricao
    });
    this.modalRef = this.modalService.open(this.modalCadastroDocumento, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    // Implementar lógica de upload do arquivo
    console.log('Arquivo selecionado:', file);
  }

  getTipoNome(tipoId: string): string {
    const tipo = this.tiposDocumento.find(t => t.id === tipoId);
    return tipo ? tipo.nome : tipoId;
  }

  getStatusClass(status: string): string {
    return status === 'Vigente' ? 'badge-success' : 'badge-danger';
  }
} 